import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { PersonalSettingsDto, SendUrlParams, User } from '../types.ts'
import { omitRequestParams } from '../utils.ts'

import { apiService } from './root.ts'

export const USER_ENDPOINTS = {
  root: '/user',
  personalSettings: '/view-column-customization',
}

export const useGetUserInfo = () =>
  useQuery({
    queryKey: ['user'],
    queryFn: () => apiService.get<User>(USER_ENDPOINTS.root),
  })

export const useGetMe = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ['me'],
    queryFn: () => apiService.get<User>(USER_ENDPOINTS.root),
    enabled: options?.enabled ?? true,
    gcTime: 0,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    refetchOnReconnect: 'always',
  })

export const useGetPersonalSettings = (userId?: number, options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: ['personalSettings', userId],
    queryFn: () => apiService.get<PersonalSettingsDto>(USER_ENDPOINTS.personalSettings),
    retry: false,
    ...options,
  })

export const useMutateSendUrl = (id: number | string, sendUrl: string) =>
  useMutation({
    mutationFn: (bodyParams: SendUrlParams) =>
      // Отче наш, Иже еси́ на небесе́х
      apiService.post<'OK' | void>(sendUrl, {
        bodyParams: omitRequestParams({ ...bodyParams, id }),
      }),
  })

export const useMutatePersonalSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (bodyParams: PersonalSettingsDto) =>
      apiService.patch<'OK' | void>(USER_ENDPOINTS.personalSettings, {
        bodyParams: omitRequestParams({ ...bodyParams }),
      }),
    onSuccess: () => {
      //замечено, что не всегда отрабатывает
      queryClient.invalidateQueries({ queryKey: ['personalSettings'] })
    },
  })
}
